import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const ViewerDashboardTab = ({ users, files, startups, investors }) => {
	const navigate = useNavigate();
	const { tenantId } = useParams();

	return (
		<div className="p-6 space-y-6">
			<h2 className="text-2xl font-semibold text-gray-900 mb-6">Dashboard Overview</h2>

			{/* KPI Cards */}
			<div className="grid grid-cols-1 md:grid-cols-4 gap-6">
				<div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
					<div className="flex items-center">
						<div className="flex-shrink-0">
							<div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
								<svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
									<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
								</svg>
							</div>
						</div>
						<div className="ml-4">
							<p className="text-sm font-medium text-gray-600">Total Users</p>
							<p className="text-2xl font-bold text-gray-900">{users.length}</p>
						</div>
					</div>
				</div>
				<div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
					<div className="flex items-center">
						<div className="flex-shrink-0">
							<div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
								<svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
									<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
								</svg>
							</div>
						</div>
						<div className="ml-4">
							<p className="text-sm font-medium text-gray-600">Files</p>
							<p className="text-2xl font-bold text-gray-900">{files.length}</p>
						</div>
					</div>
				</div>
				<div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
					<div className="flex items-center">
						<div className="flex-shrink-0">
							<div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center">
								<svg className="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
									<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
								</svg>
							</div>
						</div>
						<div className="ml-4">
							<p className="text-sm font-medium text-gray-600">Startups</p>
							<p className="text-2xl font-bold text-gray-900">{startups.length}</p>
						</div>
					</div>
				</div>
				<div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
					<div className="flex items-center">
						<div className="flex-shrink-0">
							<div className="w-12 h-12 bg-yellow-100 rounded-lg flex items-center justify-center">
								<svg className="w-6 h-6 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
									<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
								</svg>
							</div>
						</div>
						<div className="ml-4">
							<p className="text-sm font-medium text-gray-600">Investors</p>
							<p className="text-2xl font-bold text-gray-900">{investors.length}</p>
						</div>
					</div>
				</div>
			</div>

			{/* Quick Navigation */}
			<div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
				<h3 className="text-lg font-semibold text-gray-900 mb-4">Quick Navigation</h3>
				<div className="grid grid-cols-1 md:grid-cols-3 gap-4">
					<button
						onClick={() => navigate(`/${tenantId}/viewer/files`)}
						className="flex items-center p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition"
					>
						<svg className="w-8 h-8 text-blue-600 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
							<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
						</svg>
						<div className="text-left">
							<p className="font-medium text-gray-900">View Files</p>
							<p className="text-sm text-gray-500">Browse all files</p>
						</div>
					</button>
					<button
						onClick={() => navigate(`/${tenantId}/viewer/users`)}
						className="flex items-center p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition"
					>
						<svg className="w-8 h-8 text-green-600 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
							<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
						</svg>
						<div className="text-left">
							<p className="font-medium text-gray-900">View Users</p>
							<p className="text-sm text-gray-500">See all users</p>
						</div>
					</button>
					<button
						onClick={() => navigate(`/${tenantId}/viewer/reports`)}
						className="flex items-center p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition"
					>
						<svg className="w-8 h-8 text-purple-600 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
							<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
						</svg>
						<div className="text-left">
							<p className="font-medium text-gray-900">View Reports</p>
							<p className="text-sm text-gray-500">Analytics and insights</p>
						</div>
					</button>
				</div>
			</div>
		</div>
	);
};

export default ViewerDashboardTab;

